import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import CheckBox from "../../components/checkBox/CheckBox";
import MediaQueryUtils from "../../utils/MediaQueryUtils";

function DisponibilitaOffertaPerUtente(props){

    const [disponibilitaOfferta, setDisponibilitaOfferta] = useState({})
    const getAssistente = useSelector(disponibilitaOfferta => disponibilitaOfferta.wizardReducer)
    const [divComuni,setDivComuni] = useState(null)
    let isPageWide = MediaQueryUtils('(min-width: 1150px)')

    useEffect(() => {
        if (getAssistente && getAssistente.disponibilitaOfferta) {
            setDisponibilitaOfferta(getAssistente.disponibilitaOfferta)
            createDivComuni(getAssistente.disponibilitaOfferta.comune?getAssistente.disponibilitaOfferta.comune:[])
        }
    }, [])

    function createDivComuni(comuni){
        let newDivComuni = []
        comuni.forEach(comune => {
            let span = (<li><span>{comune.descrizione}</span></li>)
            newDivComuni.push(span)
        })
        setDivComuni(newDivComuni)
    }

    return (
        <div>
            <div style={{marginTop: "1rem",marginBottom:"1rem"}}>
                <span style={{fontWeight: "bold", fontSize: "20px", color: "#505050"}}>Disponibilità ad assistere:</span>
            </div>
            <div className={"row"}>
                <CheckBox id={"maschio"}
                          text={"Maschio"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaAssistenza && disponibilitaOfferta.disponibilitaAssistenza.maschio}/>
                <CheckBox id={"femmina"}
                          text={"Femmina"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaAssistenza && disponibilitaOfferta.disponibilitaAssistenza.femmina}/>
                <CheckBox id={"autosufficiente"}
                          text={"Persona autosufficiente"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaAssistenza && disponibilitaOfferta.disponibilitaAssistenza.autosufficiente}/>
                <CheckBox id={"carrozzina"}
                          disabled={true}
                          text={"Persona in carrozzina"}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaAssistenza && disponibilitaOfferta.disponibilitaAssistenza.carrozzina}/>
                <CheckBox id={"allettata"}
                          text={"Persona allettata"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaAssistenza && disponibilitaOfferta.disponibilitaAssistenza.allettata}/>
                <CheckBox id={"parzialmenteAutosufficiente"}
                          text={"Persona parzialmente autosufficiente"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaAssistenza && disponibilitaOfferta.disponibilitaAssistenza.parzialmenteAutosufficiente}/>
                <CheckBox id={"disabilita"}
                          text={"Persona affetta da disabilità mentale/psichiatrica/demenza"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaAssistenza && disponibilitaOfferta.disponibilitaAssistenza.disabilita}/>
                <div className={"row"} style={{alignItems:"center"}}>
                    <div className={"col-5"}>
                        <CheckBox id={"altro"}
                                  text={"Altro"}
                                  disabled={true}
                                  checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaAssistenza && disponibilitaOfferta.disponibilitaAssistenza.altro}/>
                    </div>
                    <div className={"col-7"} >
                        <span>: {disponibilitaOfferta && disponibilitaOfferta.disponibilitaAssistenza && disponibilitaOfferta.disponibilitaAssistenza.altroSpecificare ? disponibilitaOfferta.disponibilitaAssistenza.altroSpecificare : ""}</span>
                    </div>
                </div>
            </div>
            <div style={{marginTop: "1rem",marginBottom:"1rem"}}>
                <span style={{fontWeight: "bold", fontSize: "20px", color: "#505050"}}>Ho esperienza in/ Posso occuparmi di:</span>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}/>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>Ho esperienza</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>Lo posso fare</div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Igiene intima</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"igieneIntimaEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.igieneIntimaEsperienza}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"igieneIntimaPossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.igieneIntimaPossoFare}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Doccia</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"docciaEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.docciaEsperienza}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"docciaPossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.docciaPossoFare}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Spugnatura a letto e lavaggio capelli</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"spugnaturaLavaggioEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.spugnaturaLavaggioEsperienza}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"spugnaturaLavaggioPossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.spugnaturaLavaggioPossoFare}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Taglio della barba</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"taglioBarbaEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.taglioBarbaEsperienza}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"taglioBarbaPossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.taglioBarbaPossoFare}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Taglio della unghie</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"taglioUnghieEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.taglioUnghieEsperienza}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"taglioUnghiePossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.taglioUnghiePossoFare}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Movimentazione della persona</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"movimentazionePersonaEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.movimentazionePersonaEsperienza}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"movimentazionePersonaPossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.movimentazionePersonaPossoFare}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Utilizzo del sollevatore</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"utilizzoSollevatoreEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.utilizzoSollevatoreEsperienza}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"utilizzoSollevatorePossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi && disponibilitaOfferta.assistenteOccuparsiDi.utilizzoSollevatorePossoFare}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Lavare</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"lavareEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.lavareEsperienza ? disponibilitaOfferta.assistenteOccuparsiDi2.lavareEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"lavarePossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.lavarePossoFare ? disponibilitaOfferta.assistenteOccuparsiDi2.lavarePossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Stirare</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"stirareEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.stirareEsperienza ? disponibilitaOfferta.assistenteOccuparsiDi2.stirareEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"stirarePossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.stirarePossoFare ? disponibilitaOfferta.assistenteOccuparsiDi2.stirarePossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Preparazione pasti/diete speciali</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"preparazionePastiEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.preparazionePastiEsperienza ? disponibilitaOfferta.assistenteOccuparsiDi2.preparazionePastiEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"preparazionePastiPossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.preparazionePastiPossoFare ? disponibilitaOfferta.assistenteOccuparsiDi2.preparazionePastiPossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Pulizie di casa</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"pulizieCasaEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.pulizieCasaEsperienza ? disponibilitaOfferta.assistenteOccuparsiDi2.pulizieCasaEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"pulizieCasaPossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.pulizieCasaPossoFare ? disponibilitaOfferta.assistenteOccuparsiDi2.pulizieCasaPossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Visite mediche</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"visiteMedicheEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.visiteMedicheEsperienza ? disponibilitaOfferta.assistenteOccuparsiDi2.visiteMedicheEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"visiteMedichePossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.visiteMedichePossoFare ? disponibilitaOfferta.assistenteOccuparsiDi2.visiteMedichePossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Fare la spesa</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"spesaEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.spesaEsperienza ? disponibilitaOfferta.assistenteOccuparsiDi2.spesaEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"spesaPossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.spesaPossoFare ? disponibilitaOfferta.assistenteOccuparsiDi2.spesaPossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Disbrigo semplici pratiche burocratiche</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"praticheBurocraticheEsperienza"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.praticheBurocraticheEsperienza ? disponibilitaOfferta.assistenteOccuparsiDi2.praticheBurocraticheEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"praticheBurocratichePossoFare"}
                              disabled={true}
                              checked={disponibilitaOfferta && disponibilitaOfferta.assistenteOccuparsiDi2 && disponibilitaOfferta.assistenteOccuparsiDi2.praticheBurocratichePossoFare ? disponibilitaOfferta.assistenteOccuparsiDi2.praticheBurocratichePossoFare : false}/>
                </div>
            </div>


            <div style={{marginTop: "1rem"}}>
                <span style={{fontWeight: "bold", fontSize: "20px", color: "#505050"}}>Sono in grado di assistere persone con:</span>
            </div>
            <div className={"row"} style={{justifyContent: "space-between", width: isPageWide ? "60%" : "25%"}}>
                <CheckBox text={"Catetere"}
                          id={"catetere"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.assistenzaPersone && disponibilitaOfferta.assistenzaPersone.catetere }/>
                <CheckBox text={"Peg"}
                          id={"peg"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.assistenzaPersone && disponibilitaOfferta.assistenzaPersone.peg }/>
                <CheckBox text={"Stomia"}
                          id={"stomia"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.assistenzaPersone && disponibilitaOfferta.assistenzaPersone.stomia}/>
                <CheckBox text={"Ventilatore polmonare"}
                          id={"ventilatorePolmonare"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.assistenzaPersone && disponibilitaOfferta.assistenzaPersone.ventilatorePolmonare}/>
                <CheckBox text={"Ossigeno"}
                          id={"ossigeno"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.assistenzaPersone && disponibilitaOfferta.assistenzaPersone.ossigeno}/>
            </div>


            <div style={{marginTop: "1rem"}}>
                <span style={{fontWeight: "bold", fontSize: "20px", color: "#505050"}}>Disponibilità oraria: </span>
            </div>
            <div className={"row"} style={{justifyContent: "space-between", width: isPageWide ? "60%" : "55%"}}>
                <CheckBox text={"Assistenza h24/24"}
                          id={"h24"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaSettimanale && disponibilitaOfferta.disponibilitaSettimanale.h24}/>
                <CheckBox text={"Assistenza diurna"}
                          id={"assistenzaDiurna"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaSettimanale && disponibilitaOfferta.disponibilitaSettimanale.assistenzaDiurna}/>
                <CheckBox text={"Assistenza notturna"}
                          id={"assistenzaNotturna"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaSettimanale && disponibilitaOfferta.disponibilitaSettimanale.assistenzaNotturna}/>
                <CheckBox text={"Assistenza fine settimana"}
                          id={"assistenzaFineSettimana"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaSettimanale && disponibilitaOfferta.disponibilitaSettimanale.assistenzaFineSettimana}/>
                <CheckBox text={"Assistenza a chiamata per sostituzione malattia/ferie"}
                          id={"assistenzaChiamata"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaSettimanale && disponibilitaOfferta.disponibilitaSettimanale.assistenzaChiamata}/>
                <CheckBox text={"Con vitto"}
                          id={"vitto"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaSettimanale && disponibilitaOfferta.disponibilitaSettimanale.vitto}/>
                <CheckBox text={"Con alloggio"}
                          id={"alloggio"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.disponibilitaSettimanale && disponibilitaOfferta.disponibilitaSettimanale.alloggio}/>
            </div>

            <div style={{marginTop: "1rem"}}>
                <span style={{fontWeight: "bold", fontSize: "20px", color: "#505050"}}>Disponibilità territoriale:</span>
            </div>
            <div className={"row"} style={{justifyContent: "space-between", width: isPageWide ? "80%" : "60%"}}>
                <CheckBox text={"Tutta la Regione"}
                          id={"tuttaRegione"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.preferenzaTerritoriale && disponibilitaOfferta.preferenzaTerritoriale.tuttaRegione}/>
                <CheckBox text={"Provincia di Belluno"}
                          id={"belluno"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.preferenzaTerritoriale && disponibilitaOfferta.preferenzaTerritoriale.belluno}/>
                <CheckBox text={"Provincia di Padova"}
                          id={"padova"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.preferenzaTerritoriale && disponibilitaOfferta.preferenzaTerritoriale.padova}/>
                <CheckBox text={"Provincia di Rovigo"}
                          id={"rovigo"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.preferenzaTerritoriale && disponibilitaOfferta.preferenzaTerritoriale.rovigo}/>
                <CheckBox text={"Provincia di Treviso"}
                          id={"treviso"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.preferenzaTerritoriale && disponibilitaOfferta.preferenzaTerritoriale.treviso}/>
            </div>
            <div className={"row"} style={{justifyContent: "space-between", width: isPageWide ? "45%" : "35%"}}>
                <CheckBox text={"Provincia di Venezia"}
                          id={"venezia"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.preferenzaTerritoriale && disponibilitaOfferta.preferenzaTerritoriale.venezia}/>
                <CheckBox text={"Provincia di Verona"}
                          id={"verona"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.preferenzaTerritoriale && disponibilitaOfferta.preferenzaTerritoriale.verona}/>
                <CheckBox text={"Provincia di Vicenza"}
                          id={"vicenza"}
                          disabled={true}
                          checked={disponibilitaOfferta && disponibilitaOfferta.preferenzaTerritoriale && disponibilitaOfferta.preferenzaTerritoriale.vicenza}/>
            </div>

            <div style={{marginTop:"1rem",height: "100%"}}>
                <span style={{fontWeight: "bold", fontSize: "20px", color: "#505050"}}>Comuni di preferenza: </span>
                <br/>
                {divComuni ?<ul>
                    {divComuni}
                </ul>:<span style={{marginLeft:"1rem"}}>Nessun comune di preferenza indicato</span>}
            </div>
            
        </div>
    )

}

export default DisponibilitaOffertaPerUtente